<template>
    <v-form>
        <span class="text-subtitle-1 font-weight-medium">{{ $t(`details`) }} </span>
        <v-row>
            <v-col cols="12" md="2">
                <time-field
                    v-model="product.durationTime"
                    outlined
                    dense
                    hide-details
                    class="cursor-pointer"
                    :label="`${$t('duration_time')}`"
                    type="text"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.durationDays"
                    variant="outlined"
                    density="compact"
                    type="number"
                    :label="`${$t('duration_days')}`"
                    hide-details
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'
    import TimeField from '@/components/snippets/forms/TimeField.vue'

    @Component({
        components: {TimeField},
    })
    export class OfflineServiceFormTransfer extends Vue {
        @Prop() productType
        @Prop() tourists
        @VModel() product
    }

    export default OfflineServiceFormTransfer
</script>
